<div rds-dialog-header>
  <h2 rds-dialog-title>{{ POPUPS.TECHNICAL_RESOURCE.TITLE }}</h2>
</div>
<div rds-dialog-content [formGroup]="form" class="dialog-form">
  <rds-form-field labelPosition="top">
    <rds-control-label>{{
      POPUPS.TECHNICAL_RESOURCE.LINK_NAME_LABEL
    }}</rds-control-label>
    <input rdsInput formControlName="title" />
    @if (form.controls.title.touched && form.controls.title.errors){
    <rds-control-error> {{ ERRORS.EMPTY }} </rds-control-error>
    }
  </rds-form-field>
  <rds-form-field labelPosition="top">
    <rds-control-label>{{
      POPUPS.TECHNICAL_RESOURCE.LINK_LABEL
    }}</rds-control-label>
    <input rdsInput formControlName="url" />
    @if (form.controls.url.touched && form.controls.url.hasError('required')) {
    <rds-control-error> {{ ERRORS.EMPTY }} </rds-control-error>
    } @if (form.controls.url.touched &&
    form.controls.url.hasError('invalidUrl')) {
    <rds-control-error> {{ ERRORS.INVALID_FORMAT }} </rds-control-error>
    }
  </rds-form-field>
</div>
<div rds-dialog-actions-container>
  <button rds-secondary-button [rds-dialog-close]="false" size="m">
    {{ BUTTONS.CANCEL }}
  </button>
  <button
    rds-primary-button
    size="m"
    (click)="submit()"
    [disabled]="form.invalid"
  >
    {{ BUTTONS.ADD }}
  </button>
</div>
